import { createQueryKeys } from '@lukemorales/query-key-factory';

export const legalEntities = createQueryKeys('legalEntities', {
  retrieve: (legalEntityId: string) => [legalEntityId],
  beneficiaries: (legalEntityId: string) => [legalEntityId],
  owners: (legalEntityId: string) => [legalEntityId],
  choices: null,
  relations: (applicationId: string) => [applicationId],
  createRelation: (applicationId: string) => [applicationId],
  updateRelation: (applicationId: string) => [applicationId],
  bulkCreateRelations: (applicationId: string) => [applicationId],
  search: (value: string) => [value],
  searchByInnOrOgrn: (value: string) => [value],
});
